import TYPES from './types';
import { queryCommon } from '../api/queries';
import { listCities } from '../api/location';
import { listVoter } from '../api/voter';

export const getOfficeOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'officeList' })
      .then(({ data }) => {
        dispatch({
          type: TYPES.getOfficeOptions,
          payload: data.map(result => ({
            id: result.id,
            name: result.name,
          })),
        })
      })
  }
};

export const getStatusServiceOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'treatmentStatusList' })
      .then(response =>
        dispatch({
          type: TYPES.getStatusServiceOptions,
          payload: response.data.map(result => ({
            id: result.treatmentStatusId,
            name: result.statusName,
          })),
        })
      )
  }
}

export const getOriginsServiceOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'treatmentOriginList' })
      .then(response => {
        dispatch({
          type: TYPES.getOriginServiceOptions,
          payload: response.data.map(result => ({
            id: result.id,
            name: result.origin,
          })),
        })
      })
  }
}

export const getCategoriesServiceOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'treatmentCategoryList' })
      .then(response => {
        dispatch({
          type: TYPES.getCategoryServiceOptions,
          payload: response.data.map(result => ({
            id: result.treatmentCategoryId,
            name: result.category,
          })),
        })
      })
  }
}

export const getUsersOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'userList' })
      .then(response => {
        dispatch({
          type: TYPES.getUsersOptions,
          payload: response.data.map(result => ({
            id: result.id,
            name: result.name,
            status: result.status,
            phone: result.phone,
          })),
        })
      })
  }
}

export const getGroupsOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'electorGroupList' })
      .then(response => {
        dispatch({
          type: TYPES.getGroupsOptions,
          payload: response.data.map(result => ({
            id: result.id,
            name: result.groupName,
          })),
        })
      })
  }
}

export const getVotersOptions = params => {
  return dispatch => {
    listVoter(params)
      .then(response => {

        dispatch({
          type: TYPES.getVotersOptions,
          payload: response.data.data.map(result => {
            const {
              id,
              name,
              telephone,
              districtName,
              cityName
            } = result;

            return {
              id,
              name,
              telephone,
              districtName,
              cityName,
            }
          }),
        })
      })
  }
}

export const getDocumentTypeOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'documentTypeList' })
      .then(response =>
        dispatch({
          type: TYPES.getDocumentTypeOptions,
          payload: response.data.map(result => ({
            id: result.id,
            name: result.document,
          })),
        })
      )
  }
}

export const getAuthorsOptions = params => {
  return dispatch => {
    queryCommon({ ac: 'authorLegislativeProcesseList', params })
      .then(response => {

        dispatch({
          type: TYPES.getAuthorsOptions,
          payload: response.data.map(result => {
            const { name } = result;

            return {
              name,
            }
          }),
        })
      })
  }
}

export const getStatusLegislativeProcess = () => {
  return dispatch => {
    queryCommon({ ac: 'legislativeProcesseStatusList' })
      .then(response =>
        dispatch({
          type: TYPES.getStatusLegislativeProcessOptions,
          payload: response.data.map(result => ({
            id: result.id,
            name: result.statusName,
          })),
        })
      )
  }
}

export const getDepartments = () => {
  return dispatch => {
    queryCommon({ ac: 'departmentList' })
      .then(response =>
        dispatch({
          type: TYPES.getdepartmentOptions,
          payload: response.data.map(({ id, name, clientId }) => ({
            id,
            name,
            clientId,
          })),
        })
      )
  }
}

export const getIntegrationUserOptions = () => {
  return dispatch => {
    queryCommon({ ac: 'integrationCalendarList' })
      .then(response =>
        dispatch({
          type: TYPES.getIntegrationUserOptions,
          payload: response.data.map(result => ({
            id: result.id,
            userId: result.userId,
            isValid: result.isValid,
          })),
        })
      )
  }
}

export const getOccupationOptions = params => {
  return dispatch => {
    queryCommon({ ac: 'occupationList', params })
      .then(response =>
        dispatch({
          type: TYPES.getOccupationOptions,
          payload: response.data.map(({ id, occupation }) => ({
            id,
            name: occupation,
          })),
        })
      )
  }
}

export const getComunicationCostOptions = params => {
  return dispatch => {
    queryCommon({ ac: 'communicationCostList', params })
      .then(response =>
        dispatch({
          type: TYPES.getComunicationCostOptions,
          payload: response.data.map(({ amountMin, amountMax, costUnit, costBankSlip, clientId, typeId }) => ({
            amountMin,
            amountMax,
            costUnit,
            costBankSlip,
            clientId,
            typeId,
          })),
        })
      )
  }
}

export const getStageAmendments = () => {
  return dispatch => {
    queryCommon({ ac: 'amendmentStageList' })
      .then(response =>
        dispatch({
          type: TYPES.getStageAmendmentsOptions,
          payload: response.data.map(({ id, name, color, clientId }) => ({
            id,
            name,
            color,
            clientId,
          })),
        })
      )
  }
}

export const getCity = params => {
  return dispatch => {
    listCities(params.name)
      .then(({ data }) => {
        dispatch({
          type: TYPES.getCityOptions,
          payload: data.map(result => {
            const {
              id,
              name,
              stateAbbrev,
              stateId,
            } = result;

            return {
              id,
              stateId,
              name,
              stateAbbrev,
            }
          }),
        })
      })
  }
};
